	import React from "react";
import ReactTable from "react-table-6";
import TableLoader from "./TableLoader";
import "react-table-6/react-table.css";

const TableV6 = ({ columns, data, isLoading, handleSortBy }) => {
	return (
		<ReactTable
			minRows={0}
			columns={columns}
			data={data}
			loading={isLoading}
			showPagination={false}
			pageSize={10}
			onSortedChange={(props) => handleSortBy(props)}
			manual={true}
			resizable={false}
			LoadingComponent={() => <TableLoader isLoading={isLoading} version={6} />}
			NoDataComponent={() => !isLoading && <div className='rt-noData'>No data found</div>}
		/>
	);
};

export default TableV6;
